/** Admin email-code (2FA) trust window after successful verification. */
export const ADMIN_TWO_FA_SESSION_MS = 48 * 60 * 60 * 1000;

const TWO_FA_AT_KEY = "twoFaVerifiedAt";
const TWO_FA_EMAIL_KEY = "twoFaVerifiedEmail";

export function isAdminTwoFaWindowValid(emailForApp) {
  const verifiedAt = parseInt(localStorage.getItem(TWO_FA_AT_KEY) || "0", 10);
  const verifiedEmail = (localStorage.getItem(TWO_FA_EMAIL_KEY) || "").trim().toLowerCase();
  const norm = (emailForApp || "").trim().toLowerCase();
  if (!verifiedAt || !norm) return false;
  if (verifiedEmail !== norm) return false;
  return Date.now() - verifiedAt <= ADMIN_TWO_FA_SESSION_MS;
}

/** Firestore `adminSessionTrustedUntil` (Timestamp or plain) → epoch ms, or null. */
export function getFirestoreTrustedUntilMillis(docOrUserData) {
  const t = docOrUserData?.adminSessionTrustedUntil;
  if (!t) return null;
  if (typeof t.toMillis === "function") return t.toMillis();
  if (typeof t.seconds === "number") return t.seconds * 1000;
  return null;
}

/**
 * True if admin may skip the email code: local 48h stamp OK, or Firestore trust still valid
 * (survives clearing browser cache / site storage on the device).
 */
export function isAdminTwoFaTrustOk(emailForApp, firestoreUserDataOrContextUser) {
  if (isAdminTwoFaWindowValid(emailForApp)) return true;
  const ctx = firestoreUserDataOrContextUser;
  if (!ctx) return false;
  const ms =
    typeof ctx.adminSessionTrustedUntilMs === "number"
      ? ctx.adminSessionTrustedUntilMs
      : getFirestoreTrustedUntilMillis(ctx);
  return ms != null && Date.now() < ms;
}

export function stampAdminTwoFaVerified(emailForApp) {
  const norm = (emailForApp || "").trim().toLowerCase();
  if (!norm) return;
  localStorage.setItem(TWO_FA_AT_KEY, Date.now().toString());
  localStorage.setItem(TWO_FA_EMAIL_KEY, norm);
}
